import { atom } from "recoil"
import { deckMap } from "../questions/decks"

// should immediately fetch this in welcome page
export const questionData = atom({
	key: "questions",
	default: deckMap["2022-09-29"].questions,
})
